angular.module('zc.commonApi')

.factory 'ProjectCartButton', ($resource, $q, BaseProjectCrudService) ->
  class ProjectCartButton extends BaseProjectCrudService

  new ProjectCartButton(
    $resource
    $q
    '/api/projects/:projectId/cart_buttons/:id'
    'cart_button'
    'cart_buttons'
  )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/cart_button.service.coffee